/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Canvas_Public_Writes_Needs_TargetInputs */



/**
* | output |
* | --- |
* | "Add a writable table or an upload folder to this canvas first." |
*
* @param {Artifact_Canvas_Public_Writes_Needs_TargetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_canvas_public_writes_needs_target = /** @type {((inputs?: Artifact_Canvas_Public_Writes_Needs_TargetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Canvas_Public_Writes_Needs_TargetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge diesem Canvas zuerst eine beschreibbare Tabelle oder einen Upload-Ordner hinzu.")
	return /** @type {LocalizedString} */ ("Add a writable table or an upload folder to this canvas first.")
});